<template>
    <common-layout-component2 show-back="false" show-home="false" show-admin="false" show-log="false" show-user="false" show-logout="false" :show-notice="false" v-bind:no-image-nav="true" v-bind:simple-layout="true">

        <template v-slot:nav-message>
            <p>ログイン</p>
        </template>
        <template v-slot:body>

            <template v-if="!showVerification">
            <form v-on:submit.prevent="doLogin">

                <div class="field">
                    <label class="label" v-bind:class="{error:errMailAddress || errAuth}">メールアドレス</label>
                    <div class="control">
                        <input class="input" v-focus v-bind:class="{'error-ctrl':errMailAddress || errAuth}" ref="username" type="text" v-model:value="username" placeholder="メールアドレスを入力してください" autocomplete="off">
                    </div>
                    <template v-for="err in mailAddressErrors">
                        <div class="control" v-bind:class="{error:errMailAddress}">
                            <label>{{ err }}</label>
                        </div>
                    </template>
                </div>
                <div class="field">
                    <label class="label" v-bind:class="{error:errPassword || errAuth}">パスワード</label>
                    <div class="control">
                        <input class="input" v-bind:class="{'error-ctrl':errPassword || errAuth}" type="password" ref="password" v-model:value="password" placeholder="パスワードを入力してください" autocomplete="off">
                    </div>
                    <template v-for="err in passwordErrors">
                        <div class="control error" v-bind:class="{error:errPassword}">
                            <label>{{ err }}</label>
                        </div>
                    </template>

                    <template v-for="err in authErrors">
                        <div class="control error" v-bind:class="{error:errAuth}">
                            <label>{{ err }}</label>
                        </div>
                    </template>

                    <!--
                    <div class="control">
                        <label class="checkbox">
                            <p class="pt10"><input type="checkbox" v-model:value="remember">&nbsp;ログイン状態を保持する</p>
                        </label>
                    </div>
                    -->
                </div>

                <div class="field pt20">
                    <div class="control tc">
                        <button class="button is-login" :disabled="isProcessing">ログイン</button>
                    </div>
                </div>

            </form>

            <p class="tc pt10"><a href="" @click.prevent.stop="showModal = true"><strong>パスワードをお忘れですか？</strong></a></p>
            </template>

            <template v-if="showVerification">
            <form v-on:submit.prevent="doVerification">
                <p class="sendmail">6桁の確認コードをメールアドレスに送信しました。</p>
                <div class="field">
                    <label class="label" v-bind:class="{error:errVerification}">確認コード</label>
                    <div class="control">
                        <input class="input" v-focus v-bind:class="{'error-ctrl':errVerification}" ref="code" type="verificationCode" v-model:value="verificationCode" placeholder="確認コードを入力してください" autocomplete="off">
                    </div>
                    <template v-for="err in verificationErrors">
                        <div class="control" v-bind:class="{error:errVerification}">
                            <label>{{ err }}</label>
                        </div>
                    </template>
                </div>

                <div class="field pt20">
                    <div class="control tc">
                        <button class="button is-login" :disabled="isProcessing">確認</button>
                    </div>
                </div>

            </form>

            <p class="tc pt10"><a href="" @click.prevent.stop="resendVarification"><strong>確認コードを再度送信する</strong></a></p>
            </template>

            <modal-component v-if="showModal" is-quest="false" @modalOk="showModal = false" >
                <h4 slot="header">パスワードの確認</h4>
                <h2 slot="body" style="text-align: center">管理者にお問い合わせください。</h2>
            </modal-component>

            <modal-component v-if="showResendVerificationModal" is-quest="false" @modalOk="showResendVerificationModal = false" >
                <h4 slot="header">確認コードの再送信</h4>
                <h2 slot="body" style="text-align: center">確認コードをメールアドレスに送信しました</h2>
            </modal-component>
            <modal-component v-if="showSendVerificationErrorModal" is-quest="false" @modalOk="showSendVerificationErrorModal = false" >
                <h4 slot="header">エラー</h4>
                <h2 slot="body" style="text-align: center">しばらく経ってから再度お試しください</h2>
            </modal-component>

        </template>

    </common-layout-component2>
</template>
<script>
    import logic from './js/Login.js';
    import CommonLayoutComponent2 from '../../commons/CommonLayoutComponent2.vue';

    import BaseCheckComponent from '../../commons/BaseCheckComponent.vue';
    import TableComponent from '../../commons/TableComponent.vue';
    import ModalComponent from '../../commons/ModalComponent.vue';

    logic.components = {
        CommonLayoutComponent2,
        BaseCheckComponent,
        TableComponent,
        ModalComponent
    }

    export default logic;
</script>
<style scoped lang="scss">
    @import "../../../../sass/sp/login.scss";

    .error {
        color: rgba(255, 0, 0, 0.6) !important;
    }
    .error-ctrl {
        background-color: rgba(255, 0, 0, 0.16) !important;
    }

    .sendmail{
        margin-bottom: 30px;
        color: #666;
        font-weight: bold;
        text-align: center;
    }
</style>
